/**
 * @fileoverview Agent definition for world-event-ideation-v3.
 *
 * This agent generates ideas for significant events (historical events, prophecies, legends)
 * that could appear in the story world.
 *
 * @category world-building.events.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-event-ideation-v3',
  kind: 'primitive',
  name: 'World Event Ideation',
  description: 'Generates ideas for significant events (historical events, prophecies, legends) in your story world.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.events.creation',
    usedBy: ['use-world-event-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-event-details-ideation-v3',
      'world-event-details-generator-v3',
    ],
  },
};
